module.exports = __webpack_public_path__ + "img/305.01b2e35f.png";